export default __webpack_public_path__ + "static/media/game_console.0d3933b2.svg";